import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

let div = document.getElementById('reservation-system');
if (div) {
  const root = ReactDOM.createRoot(div);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}